import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const Feedback3 = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../../images/feedback_3.jpg"
      alt="collar inteligente Kolyy"
    />
  );
};

export default Feedback3;
